import styled from "styled-components";

const RootContainer = styled.div`
  border-radius: 8px;
  overflow: auto;
`;

const GridTable = styled.table`
  width: 100%;
  table-layout: fixed;
  background-color: white;
  border-radius: 8px;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
  thead {
    background-color: #ececec;
  }
  td {
    padding: 0px;
    text-align: center;
    font-size: 14px;
    height: 50px;
    min-height: 50px;
    max-height: 50px;
    width: 64px;
    min-width: 58px;
    max-width: 58px;
    white-space: normal;
    position: relative;
  }
  td:not(:last-child) {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

const Input = styled.input`
  ::placeholder {
    color: #d6d6d6;
    border-radius: 8px;
    border: 2px solid #d6d6d6;
    padding: 1px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  }
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  text-align: center;
  outline: none;
  font-weight: bold;
  font-size: 18px;
  ::placeholder {
    font-weight: normal;
  }
  :disabled {
    background-color: #ececec;
  }
`;

const ColorImage = styled.img`
  object-fit: cover;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  overflow: hidden;
`;

const VariationPriceContainer = styled.div`
  padding: 0px 2px;
  position: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 2;
  font-size: 10px;
  font-weight: bold;
`;

const modules = {
  GridTable,
  RootContainer,
  Input,
  ColorImage,
  VariationPriceContainer,
};

export default modules;
